export const darkBlue = "#223849";
export const lightBlue = "#0183C5";
export const lightGray = "#EBEBEB";
export const black = "#070707";
